// import React, { useState, useEffect } from 'react';
// import axios from 'axios';

// export default function TelegramSettings() {
//   const [settings, setSettings] = useState({
//     bot_token: '',
//     chat_id: '',
//     notifications_enabled: true,
//     notify_on_campaign_start: true,
//     notify_on_campaign_end: true,
//     notify_on_error: true,
//     notify_on_new_message: false
//   });
  
//   const [loading, setLoading] = useState(false);
//   const [testing, setTesting] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });
//   const [showToken, setShowToken] = useState(false);

//   useEffect(() => {
//     loadSettings();
//   }, []);

//   const loadSettings = async () => {
//     try {
//       const res = await axios.get('/telegram/settings');
//       setSettings(prev => ({ ...prev, ...res.data }));
//     } catch (err) {
//       console.error('Error loading settings:', err);
//     }
//   };

//   const handleSave = async () => {
//     setLoading(true);
//     setMessage({ type: '', text: '' });
    
//     try {
//       await axios.post('/telegram/settings', settings);
//       setMessage({ type: 'success', text: 'Настройки сохранены!' });
//     } catch (err) {
//       setMessage({ type: 'error', text: 'Ошибка при сохранении' });
//     } finally {
//       setLoading(false);
//       setTimeout(() => setMessage({ type: '', text: '' }), 3000);
//     }
//   };

//   const handleTest = async () => {
//     if (!settings.bot_token || !settings.chat_id) {
//       setMessage({ type: 'error', text: 'Заполните токен и Chat ID' });
//       return;
//     }

//     setTesting(true);
//     setMessage({ type: '', text: '' });

//     try {
//       await axios.post('/telegram/test', {
//         bot_token: settings.bot_token,
//         chat_id: settings.chat_id
//       });
//       setMessage({ type: 'success', text: 'Тестовое сообщение отправлено! Проверьте Telegram' });
//     } catch (err) {
//       setMessage({ type: 'error', text: 'Ошибка: ' + (err.response?.data?.error || 'Не удалось отправить') });
//     } finally {
//       setTesting(false);
//     }
//   };

//   return (
//     <div className="bg-white rounded-2xl shadow-md p-6">
//       <h2 className="text-xl font-semibold mb-6">🤖 Telegram уведомления</h2>

//       {message.text && (
//         <div className={`p-3 rounded-xl mb-4 ${
//           message.type === 'success' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
//         }`}>
//           {message.text}
//         </div>
//       )}

//       <div className="space-y-6">
//         {/* Инструкция */}
//         <div className="bg-blue-50 p-4 rounded-xl">
//           <h3 className="font-semibold text-blue-700 mb-2">Как настроить:</h3>
//           <ol className="text-sm text-blue-600 space-y-1 list-decimal ml-4">
//             <li>Напишите @BotFather в Telegram и создайте нового бота</li>
//             <li>Получите токен бота</li>
//             <li>Напишите вашему боту любое сообщение</li>
//             <li>Узнайте ваш Chat ID у @userinfobot</li>
//             <li>Вставьте данные ниже и нажмите "Тест"</li>
//           </ol>
//         </div>

//         {/* Токен бота */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Токен бота
//           </label>
//           <div className="relative">
//             <input
//               type={showToken ? "text" : "password"}
//               value={settings.bot_token}
//               onChange={(e) => setSettings({...settings, bot_token: e.target.value})}
//               placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
//               className="w-full border rounded-xl px-4 py-2 pr-24 focus:ring-2 focus:ring-blue-400"
//             />
//             <button
//               onClick={() => setShowToken(!showToken)}
//               className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
//             >
//               {showToken ? "🙈" : "👁️"}
//             </button>
//           </div>
//         </div>

//         {/* Chat ID */}
//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">
//             Chat ID
//           </label>
//           <input
//             type="text"
//             value={settings.chat_id}
//             onChange={(e) => setSettings({...settings, chat_id: e.target.value})}
//             placeholder="123456789"
//             className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400"
//           />
//         </div>

//         {/* Настройки уведомлений */}
//         <div className="border-t pt-4">
//           <h3 className="font-semibold mb-3">Типы уведомлений</h3>
          
//           <div className="space-y-3">
//             <label className="flex items-center space-x-3">
//               <input
//                 type="checkbox"
//                 checked={settings.notifications_enabled}
//                 onChange={(e) => setSettings({...settings, notifications_enabled: e.target.checked})}
//                 className="w-4 h-4 text-blue-600"
//               />
//               <span className="text-sm text-gray-700">Включить уведомления</span>
//             </label>

//             {settings.notifications_enabled && (
//               <>
//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={settings.notify_on_campaign_start}
//                     onChange={(e) => setSettings({...settings, notify_on_campaign_start: e.target.checked})}
//                     className="w-4 h-4 text-blue-600"
//                   />
//                   <span className="text-sm text-gray-700">🚀 Запуск кампании</span>
//                 </label>

//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={settings.notify_on_campaign_end}
//                     onChange={(e) => setSettings({...settings, notify_on_campaign_end: e.target.checked})}
//                     className="w-4 h-4 text-blue-600"
//                   />
//                   <span className="text-sm text-gray-700">✅ Завершение кампании</span>
//                 </label>

//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={settings.notify_on_error}
//                     onChange={(e) => setSettings({...settings, notify_on_error: e.target.checked})}
//                     className="w-4 h-4 text-blue-600"
//                   />
//                   <span className="text-sm text-gray-700">⚠️ Ошибки</span>
//                 </label>

//                 <label className="flex items-center space-x-3">
//                   <input
//                     type="checkbox"
//                     checked={settings.notify_on_new_message}
//                     onChange={(e) => setSettings({...settings, notify_on_new_message: e.target.checked})}
//                     className="w-4 h-4 text-blue-600"
//                   />
//                   <span className="text-sm text-gray-700">💬 Новые ответы</span>
//                 </label>
//               </>
//             )}
//           </div>
//         </div>

//         {/* Кнопки */}
//         <div className="flex space-x-3">
//           <button
//             onClick={handleTest}
//             disabled={testing || !settings.bot_token || !settings.chat_id}
//             className={`px-4 py-2 rounded-xl transition ${
//               testing || !settings.bot_token || !settings.chat_id
//                 ? 'bg-gray-300 cursor-not-allowed'
//                 : 'bg-green-600 hover:bg-green-700 text-white'
//             }`}
//           >
//             {testing ? 'Отправка...' : '📨 Тест'}
//           </button>

//           <button
//             onClick={handleSave}
//             disabled={loading}
//             className={`flex-1 px-4 py-2 rounded-xl transition ${
//               loading
//                 ? 'bg-blue-300 cursor-not-allowed'
//                 : 'bg-blue-600 hover:bg-blue-700 text-white'
//             }`}
//           >
//             {loading ? 'Сохранение...' : '💾 Сохранить настройки'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';
// import { API_BASE } from '../api/api';

// // ===== BILLING BLOCK =====
// function BillingBlock() {
//   const [billing, setBilling] = useState(null);
//   const [plans, setPlans] = useState([]);   // ← список тарифов с бэка
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const navigate = useNavigate();

//   useEffect(() => {
//     loadBilling();
//     loadPlans();
//   }, []);

//   const loadBilling = async () => {
//     try {
//       setLoading(true);
//       setError(null);
//       const res = await fetch(`${API_BASE}/billing/me`, { credentials: 'include' });
//       if (res.status === 401) { navigate('/login'); return; }
//       if (!res.ok) throw new Error(`Ошибка сервера: ${res.status}`);
//       setBilling(await res.json());
//     } catch (err) {
//       setError(err.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const loadPlans = async () => {
//     try {
//       const res = await fetch(`${API_BASE}/api/payments/tariffs`);
//       const data = await res.json();
//       // Оставляем только платные тарифы
//       setPlans(data.filter(p => p.price > 0));
//     } catch (err) {
//       console.error("Ошибка загрузки тарифов:", err);
//     }
//   };

//   const buy = async (tariff) => {
//     try {
//       const res = await fetch(`${API_BASE}/payments/create-payment`, {
//         method: "POST",
//         credentials: 'include',
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ tariff }),
//       });
//       if (!res.ok) { alert("Ошибка сервера: " + (await res.text())); return; }
//       const data = await res.json();
//       if (data.url) window.location.href = data.url;
//       else alert("Ошибка: " + JSON.stringify(data));
//     } catch (err) {
//       alert("Ошибка запроса: " + err.message);
//     }
//   };

//   const formatDate = (iso) => {
//     if (!iso) return "—";
//     try {
//       return new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
//     } catch { return "—"; }
//   };

//   if (loading) return <div className="bg-white rounded-2xl shadow-md p-6 text-gray-500">Загрузка тарифа...</div>;
//   if (error) return <div className="bg-white rounded-2xl shadow-md p-6 text-red-500">Ошибка: {error}</div>;

//   const isFree = !billing?.plan || billing.plan === 'free';
//   const planColors = { free: '#6b7280', test: '#3b82f6', medium: '#eab308', gold: '#8b5cf6' };
//   const planColor = planColors[billing?.plan] || '#6b7280';

//   return (
//     <div className="bg-white rounded-2xl shadow-md p-6">
//       <h2 className="text-xl font-semibold mb-6">💳 Тариф и оплата</h2>

//       <div className="mb-6">
//         <div className="mb-2">
//           <span className="text-sm text-gray-500">Текущий тариф: </span>
//           <b style={{ color: planColor, fontSize: 16 }}>{billing.plan || 'free'}</b>
//         </div>

//         <div className="text-sm text-gray-600 mb-4">
//           {billing.plan_expires
//             ? <>Активен до: <b>{formatDate(billing.plan_expires)}</b></>
//             : <span className="text-gray-400">Срок не установлен</span>
//           }
//         </div>

//         {isFree && (
//           <div className="bg-blue-50 border border-blue-200 rounded-xl p-4 text-sm text-blue-800 mb-4">
//             У вас бесплатный план. Выберите тариф, чтобы увеличить лимиты.
//           </div>
//         )}

//         {!isFree && (
//           <button
//             onClick={() => buy(billing.plan)}
//             className="px-5 py-2.5 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition font-medium"
//           >
//             Продлить тариф
//           </button>
//         )}
//       </div>

//       <div className="border-t pt-4">
//         <h3 className="text-sm font-medium text-gray-700 mb-3">Сменить тариф:</h3>
//         <div className="flex flex-wrap gap-2">
//           {plans.map(p => (
//             <button
//               key={p.tariff}
//               onClick={() => buy(p.tariff)}
//               className="px-4 py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition"
//             >
//               {p.name} — {p.price_display}
//             </button>
//           ))}
//           {plans.length === 0 && (
//             <div className="text-sm text-gray-400">Загрузка тарифов...</div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// // ===== TELEGRAM BLOCK =====
// function TelegramBlock() {
//   const [settings, setSettings] = useState({
//     bot_token: '',
//     chat_id: '',
//     notifications_enabled: true,
//     notify_on_campaign_start: true,
//     notify_on_campaign_end: true,
//     notify_on_error: true,
//     notify_on_new_message: false
//   });
//   const [loading, setLoading] = useState(false);
//   const [testing, setTesting] = useState(false);
//   const [message, setMessage] = useState({ type: '', text: '' });
//   const [showToken, setShowToken] = useState(false);

//   useEffect(() => { loadSettings(); }, []);

//   const loadSettings = async () => {
//     try {
//       const res = await axios.get('/telegram/settings');
//       setSettings(prev => ({ ...prev, ...res.data }));
//     } catch (err) {
//       console.error('Error loading settings:', err);
//     }
//   };

//   const handleSave = async () => {
//     setLoading(true);
//     setMessage({ type: '', text: '' });
//     try {
//       await axios.post('/telegram/settings', settings);
//       setMessage({ type: 'success', text: 'Настройки сохранены!' });
//     } catch (err) {
//       setMessage({ type: 'error', text: 'Ошибка при сохранении' });
//     } finally {
//       setLoading(false);
//       setTimeout(() => setMessage({ type: '', text: '' }), 3000);
//     }
//   };

//   const handleTest = async () => {
//     if (!settings.bot_token || !settings.chat_id) {
//       setMessage({ type: 'error', text: 'Заполните токен и Chat ID' });
//       return;
//     }
//     setTesting(true);
//     setMessage({ type: '', text: '' });
//     try {
//       await axios.post('/telegram/test', {
//         bot_token: settings.bot_token,
//         chat_id: settings.chat_id
//       });
//       setMessage({ type: 'success', text: 'Тестовое сообщение отправлено!' });
//     } catch (err) {
//       setMessage({ type: 'error', text: 'Ошибка: ' + (err.response?.data?.error || 'Не удалось отправить') });
//     } finally {
//       setTesting(false);
//     }
//   };

//   return (
//     <div className="bg-white rounded-2xl shadow-md p-6">
//       <h2 className="text-xl font-semibold mb-6">🤖 Telegram уведомления</h2>

//       {message.text && (
//         <div className={`p-3 rounded-xl mb-4 ${
//           message.type === 'success' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
//         }`}>
//           {message.text}
//         </div>
//       )}

//       <div className="space-y-6">
//         <div className="bg-blue-50 p-4 rounded-xl">
//           <h3 className="font-semibold text-blue-700 mb-2">Как настроить:</h3>
//           <ol className="text-sm text-blue-600 space-y-1 list-decimal ml-4">
//             <li>Напишите @BotFather в Telegram и создайте нового бота</li>
//             <li>Получите токен бота</li>
//             <li>Напишите вашему боту любое сообщение</li>
//             <li>Узнайте ваш Chat ID у @userinfobot</li>
//             <li>Вставьте данные ниже и нажмите "Тест"</li>
//           </ol>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Токен бота</label>
//           <div className="relative">
//             <input
//               type={showToken ? "text" : "password"}
//               value={settings.bot_token}
//               onChange={(e) => setSettings({...settings, bot_token: e.target.value})}
//               placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
//               className="w-full border rounded-xl px-4 py-2 pr-12 focus:ring-2 focus:ring-blue-400 focus:outline-none"
//             />
//             <button
//               type="button"
//               onClick={() => setShowToken(!showToken)}
//               className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
//             >
//               {showToken ? "🙈" : "👁️"}
//             </button>
//           </div>
//         </div>

//         <div>
//           <label className="block text-sm font-medium text-gray-700 mb-1">Chat ID</label>
//           <input
//             type="text"
//             value={settings.chat_id}
//             onChange={(e) => setSettings({...settings, chat_id: e.target.value})}
//             placeholder="123456789"
//             className="w-full border rounded-xl px-4 py-2 focus:ring-2 focus:ring-blue-400 focus:outline-none"
//           />
//         </div>

//         <div className="border-t pt-4">
//           <h3 className="font-semibold mb-3">Типы уведомлений</h3>
//           <div className="space-y-3">
//             <label className="flex items-center space-x-3">
//               <input type="checkbox" checked={settings.notifications_enabled}
//                 onChange={(e) => setSettings({...settings, notifications_enabled: e.target.checked})}
//                 className="w-4 h-4 text-blue-600" />
//               <span className="text-sm text-gray-700">Включить уведомления</span>
//             </label>

//             {settings.notifications_enabled && (
//               <>
//                 {[
//                   ['notify_on_campaign_start', '🚀 Запуск кампании'],
//                   ['notify_on_campaign_end', '✅ Завершение кампании'],
//                   ['notify_on_error', '⚠️ Ошибки'],
//                   ['notify_on_new_message', '💬 Новые ответы'],
//                 ].map(([key, label]) => (
//                   <label key={key} className="flex items-center space-x-3">
//                     <input type="checkbox" checked={settings[key]}
//                       onChange={(e) => setSettings({...settings, [key]: e.target.checked})}
//                       className="w-4 h-4 text-blue-600" />
//                     <span className="text-sm text-gray-700">{label}</span>
//                   </label>
//                 ))}
//               </>
//             )}
//           </div>
//         </div>

//         <div className="flex gap-3 flex-wrap">
//           <button
//             onClick={handleTest}
//             disabled={testing || !settings.bot_token || !settings.chat_id}
//             className={`px-4 py-2 rounded-xl transition ${
//               testing || !settings.bot_token || !settings.chat_id
//                 ? 'bg-gray-300 cursor-not-allowed'
//                 : 'bg-green-600 hover:bg-green-700 text-white'
//             }`}
//           >
//             {testing ? 'Отправка...' : '📨 Тест'}
//           </button>

//           <button
//             onClick={handleSave}
//             disabled={loading}
//             className={`flex-1 px-4 py-2 rounded-xl transition ${
//               loading ? 'bg-blue-300 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-700 text-white'
//             }`}
//           >
//             {loading ? 'Сохранение...' : '💾 Сохранить настройки'}
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ===== ОСНОВНАЯ СТРАНИЦА =====
// export default function TelegramSettings() {
//   return (
//     <div className="min-h-screen bg-gray-50 p-4 md:p-8">
//       <h1 className="text-2xl md:text-3xl font-bold text-gray-800 mb-6">⚙️ Настройки</h1>

//       <div className="space-y-6 max-w-3xl">
//         <BillingBlock />
//         <TelegramBlock />
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API_BASE } from '../api/api';

// ===== BILLING BLOCK =====
function BillingBlock() {
  const [billing, setBilling] = useState(null);
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    loadBilling();
    loadPlans();
  }, []);

  const loadBilling = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await fetch(`${API_BASE}/billing/me`, { credentials: 'include' });
      if (res.status === 401) { navigate('/login'); return; }
      if (!res.ok) throw new Error(`Ошибка сервера: ${res.status}`);
      setBilling(await res.json());
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadPlans = async () => {
    try {
      const res = await fetch(`${API_BASE}/api/payments/tariffs`);
      const data = await res.json();
      setPlans(data.filter(p => p.price > 0));
    } catch (err) {
      console.error("Ошибка загрузки тарифов:", err);
    }
  };

  const buy = async (tariff) => {
    try {
      const res = await fetch(`${API_BASE}/payments/create-payment`, {
        method: "POST",
        credentials: 'include',
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ tariff }),
      });
      if (!res.ok) { alert("Ошибка сервера: " + (await res.text())); return; }
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else alert("Ошибка: " + JSON.stringify(data));
    } catch (err) {
      alert("Ошибка запроса: " + err.message);
    }
  };

  const formatDate = (iso) => {
    if (!iso) return "—";
    try {
      return new Date(iso).toLocaleDateString('ru-RU', { day: '2-digit', month: '2-digit', year: 'numeric' });
    } catch { return "—"; }
  };

  if (loading) return <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 text-gray-500 text-sm">Загрузка тарифа...</div>;
  if (error) return <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 text-red-500 text-sm">Ошибка: {error}</div>;

  const isFree = !billing?.plan || billing.plan === 'free';
  const planColors = { free: '#6b7280', test: '#3b82f6', medium: '#eab308', gold: '#8b5cf6' };
  const planColor = planColors[billing?.plan] || '#6b7280';

  return (
    <div className="bg-white rounded-2xl shadow-md p-4 md:p-6">
      <h2 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">💳 Тариф и оплата</h2>

      <div className="mb-5 md:mb-6">
        <div className="mb-2">
          <span className="text-xs md:text-sm text-gray-500">Текущий тариф: </span>
          <b style={{ color: planColor }} className="text-base md:text-lg">
            {billing.plan || 'free'}
          </b>
        </div>

        <div className="text-xs md:text-sm text-gray-600 mb-4">
          {billing.plan_expires
            ? <>Активен до: <b>{formatDate(billing.plan_expires)}</b></>
            : <span className="text-gray-400">Срок не установлен</span>
          }
        </div>

        {isFree && (
          <div className="bg-blue-50 border border-blue-200 rounded-xl p-3 md:p-4 text-xs md:text-sm text-blue-800 mb-4">
            У вас бесплатный план. Выберите тариф, чтобы увеличить лимиты.
          </div>
        )}

        {!isFree && (
          <button
            onClick={() => buy(billing.plan)}
            className="w-full md:w-auto px-5 py-2.5 rounded-xl bg-blue-600 text-white hover:bg-blue-700 transition font-medium text-sm"
          >
            Продлить тариф
          </button>
        )}
      </div>

      <div className="border-t pt-4">
        <h3 className="text-xs md:text-sm font-medium text-gray-700 mb-3">
          Сменить тариф:
        </h3>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:flex md:flex-wrap gap-2">
          {plans.map(p => (
            <button
              key={p.tariff}
              onClick={() => buy(p.tariff)}
              className="w-full md:w-auto px-3 md:px-4 py-2.5 md:py-2 rounded-xl border border-gray-300 text-gray-700 hover:bg-gray-50 transition text-sm flex items-center justify-between md:justify-start gap-2"
            >
              <span className="font-medium">{p.name}</span>
              <span className="text-gray-500 text-xs md:text-sm">{p.price_display}</span>
            </button>
          ))}
          {plans.length === 0 && (
            <div className="text-xs md:text-sm text-gray-400">Загрузка тарифов...</div>
          )}
        </div>
      </div>
    </div>
  );
}

// ===== TELEGRAM BLOCK =====
function TelegramBlock() {
  const [settings, setSettings] = useState({
    bot_token: '',
    chat_id: '',
    notifications_enabled: true,
    notify_on_campaign_start: true,
    notify_on_campaign_end: true,
    notify_on_error: true,
    notify_on_new_message: false
  });
  const [loading, setLoading] = useState(false);
  const [testing, setTesting] = useState(false);
  const [message, setMessage] = useState({ type: '', text: '' });
  const [showToken, setShowToken] = useState(false);

  useEffect(() => { loadSettings(); }, []);

  const loadSettings = async () => {
    try {
      const res = await axios.get('/telegram/settings');
      setSettings(prev => ({ ...prev, ...res.data }));
    } catch (err) {
      console.error('Error loading settings:', err);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage({ type: '', text: '' });
    try {
      await axios.post('/telegram/settings', settings);
      setMessage({ type: 'success', text: 'Настройки сохранены!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Ошибка при сохранении' });
    } finally {
      setLoading(false);
      setTimeout(() => setMessage({ type: '', text: '' }), 3000);
    }
  };

  const handleTest = async () => {
    if (!settings.bot_token || !settings.chat_id) {
      setMessage({ type: 'error', text: 'Заполните токен и Chat ID' });
      return;
    }
    setTesting(true);
    setMessage({ type: '', text: '' });
    try {
      await axios.post('/telegram/test', {
        bot_token: settings.bot_token,
        chat_id: settings.chat_id
      });
      setMessage({ type: 'success', text: 'Тестовое сообщение отправлено!' });
    } catch (err) {
      setMessage({ type: 'error', text: 'Ошибка: ' + (err.response?.data?.error || 'Не удалось отправить') });
    } finally {
      setTesting(false);
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-md p-4 md:p-6">
      <h2 className="text-lg md:text-xl font-semibold mb-4 md:mb-6">🤖 Telegram уведомления</h2>

      {message.text && (
        <div className={`p-3 rounded-xl mb-4 text-sm ${
          message.type === 'success' ? 'bg-green-50 text-green-600' : 'bg-red-50 text-red-600'
        }`}>
          {message.text}
        </div>
      )}

      <div className="space-y-5 md:space-y-6">
        <div className="bg-blue-50 p-3 md:p-4 rounded-xl">
          <h3 className="font-semibold text-blue-700 mb-2 text-sm md:text-base">
            Как настроить:
          </h3>
          <ol className="text-xs md:text-sm text-blue-600 space-y-1 list-decimal ml-4">
            <li>Напишите @BotFather в Telegram и создайте бота</li>
            <li>Получите токен бота</li>
            <li>Напишите боту любое сообщение</li>
            <li>Узнайте Chat ID у @userinfobot</li>
            <li>Вставьте данные и нажмите "Тест"</li>
          </ol>
        </div>

        <div>
          <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1">
            Токен бота
          </label>
          <div className="relative">
            <input
              type={showToken ? "text" : "password"}
              value={settings.bot_token}
              onChange={(e) => setSettings({...settings, bot_token: e.target.value})}
              placeholder="123456789:ABCdefGHIjklMNOpqrsTUVwxyz"
              className="w-full border rounded-xl px-3 md:px-4 py-2 pr-12 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
            />
            <button
              type="button"
              onClick={() => setShowToken(!showToken)}
              className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
            >
              {showToken ? "🙈" : "👁️"}
            </button>
          </div>
        </div>

        <div>
          <label className="block text-xs md:text-sm font-medium text-gray-700 mb-1">
            Chat ID
          </label>
          <input
            type="text"
            value={settings.chat_id}
            onChange={(e) => setSettings({...settings, chat_id: e.target.value})}
            placeholder="123456789"
            className="w-full border rounded-xl px-3 md:px-4 py-2 text-sm focus:ring-2 focus:ring-blue-400 focus:outline-none"
          />
        </div>

        <div className="border-t pt-4">
          <h3 className="font-semibold mb-3 text-sm md:text-base">Типы уведомлений</h3>
          <div className="space-y-3">
            <label className="flex items-center gap-3 cursor-pointer py-1">
              <input
                type="checkbox"
                checked={settings.notifications_enabled}
                onChange={(e) => setSettings({...settings, notifications_enabled: e.target.checked})}
                className="w-5 h-5 text-blue-600 flex-shrink-0"
              />
              <span className="text-sm text-gray-700">Включить уведомления</span>
            </label>

            {settings.notifications_enabled && (
              <>
                {[
                  ['notify_on_campaign_start', '🚀 Запуск кампании'],
                  ['notify_on_campaign_end', '✅ Завершение кампании'],
                  ['notify_on_error', '⚠️ Ошибки'],
                  ['notify_on_new_message', '💬 Новые ответы'],
                ].map(([key, label]) => (
                  <label key={key} className="flex items-center gap-3 cursor-pointer py-1 pl-4">
                    <input
                      type="checkbox"
                      checked={settings[key]}
                      onChange={(e) => setSettings({...settings, [key]: e.target.checked})}
                      className="w-5 h-5 text-blue-600 flex-shrink-0"
                    />
                    <span className="text-sm text-gray-700">{label}</span>
                  </label>
                ))}
              </>
            )}
          </div>
        </div>

        {/* Кнопки — на мобильном стек */}
        <div className="flex flex-col md:flex-row gap-2 md:gap-3">
          <button
            onClick={handleTest}
            disabled={testing || !settings.bot_token || !settings.chat_id}
            className={`w-full md:w-auto px-4 py-2.5 rounded-xl transition text-sm font-medium ${
              testing || !settings.bot_token || !settings.chat_id
                ? 'bg-gray-300 cursor-not-allowed text-gray-500'
                : 'bg-green-600 hover:bg-green-700 text-white'
            }`}
          >
            {testing ? 'Отправка...' : '📨 Тест'}
          </button>

          <button
            onClick={handleSave}
            disabled={loading}
            className={`w-full md:flex-1 px-4 py-2.5 rounded-xl transition text-sm font-medium ${
              loading
                ? 'bg-blue-300 cursor-not-allowed text-white'
                : 'bg-blue-600 hover:bg-blue-700 text-white'
            }`}
          >
            {loading ? 'Сохранение...' : '💾 Сохранить настройки'}
          </button>
        </div>
      </div>
    </div>
  );
}

// ===== ОСНОВНАЯ СТРАНИЦА =====
export default function TelegramSettings() {
  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-8">
      <h1 className="text-xl md:text-3xl font-bold text-gray-800 mb-4 md:mb-6">
        ⚙️ Настройки
      </h1>

      <div className="space-y-4 md:space-y-6 max-w-3xl">
        <BillingBlock />
        <TelegramBlock />
      </div>
    </div>
  );
}